import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { FetchPaginatedNotificationsResData } from "./FetchPaginatedNotificationsResData";

const ENDPOINT = "/notifications/notifications_paginated";

export class FetchPaginatedNotificationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchPaginatedNotificationsReqData;

    constructor(payload: FetchPaginatedNotificationsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchPaginatedNotificationsResData> {
        var res = await this.executeCommand(this.payload);
        return new FetchPaginatedNotificationsResData(res);
    }
}

export class FetchPaginatedNotificationsReqData implements IPaginationFilter {
    startDate: Date;
    endDate: Date;
    notificationTypeListFilter: Array<NotificationTypesEnum>;
    markedAsRead: boolean;
    resultCode: number;
    device: string;
    queryLimit: number;
    offset: number;
    orderBy: string[];
    orderByDescending: boolean[];
}
